import Vue from 'vue';
import Router from 'vue-router';

import DrugChartReportPage from '../layouts/reports/DrugChartReportPage'
import DrugCombinationsReportPage from '../layouts/reports/DrugCombinationsReportPage'
import FonterraReportPage from '../layouts/reports/FonterraReportPage'
import LoginPage from '../layouts/LoginPage'
import ReportsPage from '../layouts/ReportsPage'
import VaDrugReportPage from '../layouts/reports/VaDrugReportPage'

import ClientDashboardPage from '../layouts/ClientDashboardPage'
import ClientsListPage from '../layouts/ClientsListPage'

import DryCowConsultPage from '../layouts/dry_cow/ConsultPage'
import DryCowConsultSummaryPage from '../layouts/dry_cow/ConsultSummaryPage'

import SpringConsultPage from '../layouts/spring/ConsultPage'
import SpringReviewPage from '../layouts/spring/ReviewPage'
import SpringReviewSummaryPage from '../layouts/spring/ReviewSummaryPage'

import WinterConsultPage from '../layouts/winter/ConsultPage'
import WinterConsultSummaryPage from '../layouts/winter/ConsultSummaryPage'


import GeneralFarmConsultPage from '../layouts/general_farm/ConsultPage'
// import GeneralFarmConsultSummaryPage from '../layouts/general_farm/ConsultSummaryPage'

// import ClientErrorsPage from '../layouts/ClientErrorsPage'


Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: ClientsListPage },
    { path: '/client/:client_id', component: ClientDashboardPage, name: 'client_dashboard' },
    { path: '/login', component: LoginPage },

    // { path: '/client_errors', component: ClientErrorsPage, name: 'client_errors' },

    //Consults
    { path: '/client/:client_id/winter_consult/:season/:history?',       component: WinterConsultPage,  name: 'winter_consult'},
    { path: '/client/:client_id/spring_consult/:season/:history?',       component: SpringConsultPage,  name: 'spring_consult'},
    { path: '/client/:client_id/spring_review/:season/:history?',        component: SpringReviewPage,   name: 'spring_review' },
    { path: '/client/:client_id/dry_cow_consult/:season/:history?',      component: DryCowConsultPage,  name: 'dry_cow_consult' },
    { path: '/client/:client_id/general_farm_consult/:season/:history?', component: GeneralFarmConsultPage,  name: 'general_farm_consult' },

    // Summary Reports
    { path: '/summary_report/:client_id/spring_review/:season',  component: SpringReviewSummaryPage,  name: 'spring_review_summary_report' },
    { path: '/summary_report/:client_id/winter_consult/:season', component: WinterConsultSummaryPage, name: 'winter_consult_summary_report' },
    { path: '/summary_report/:client_id/dry_cow_consult/:season', component: DryCowConsultSummaryPage, name: 'dry_cow_consult_summary_report' },
    // { path: '/summary_report/:client_id/general_farm_consult/:season', component: GeneralFarmConsultSummaryPage, name: 'general_farm_consult_summary_report' },

    { path: '/client/:client_id/reports', component: ReportsPage, name: 'client_reports' },
    { path: '/client/:client_id/reports/va_drug_chart', component: VaDrugReportPage, name: 'va_drug_chart' },
    { path: '/client/:client_id/reports/drug_chart', component: DrugChartReportPage, name: 'drug_chart' },
    { path: '/client/:client_id/reports/drug_combinations', component: DrugCombinationsReportPage, name: 'drug_combinations' },
    { path: '/client/:client_id/reports/fonterra', component: FonterraReportPage, name: 'fonterra_report' },

    { path: '*', redirect: '/' }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired)
  {
    // TODO: remove "!Object.keys(JSON.parse(loggedIn)).includes('id')" was a cache fix
    if (loggedIn && !Object.keys(JSON.parse(loggedIn)).includes('id'))
    {
      // user is logged with old data and doesnt have id
      return next('/login');
    }
    if (!loggedIn ) {
      // user is not logged
      return next('/login');
    }
  }


  next();
})